import { useState } from 'react';
import { inTab, type Shipment } from './sample';

/** Which tab, search words and filters are chosen, and the shipments that match them */
export function useShipmentFilters(all: Shipment[]) {
  const [group, setGroup] = useState('Active');
  const [search, setSearch] = useState('');
  const [mode, setMode] = useState('all');
  const [stage, setStage] = useState('all');
  const [customer, setCustomer] = useState('all');
  const [page, setPage] = useState(1);

  const q = search.trim().toLowerCase();
  const shown = all
    .filter((s) => inTab(group, s))
    .filter((s) => mode === 'all' || s.mode === mode)
    .filter((s) => stage === 'all' || s.stage === stage)
    .filter((s) => customer === 'all' || s.customer === customer)
    .filter(
      (s) => !q || [s.srb, s.customer, s.from.city, s.to.city, s.agent, s.cargo].join(' ').toLowerCase().includes(q),
    );

  // changing any filter goes back to the first page
  const reset =
    <T>(set: (v: T) => void) =>
    (v: T) => {
      set(v);
      setPage(1);
    };
  return {
    group,
    // a new tab starts with no stage chosen
    setGroup: (v: string) => {
      setGroup(v);
      setStage('all');
      setPage(1);
    },
    search,
    setSearch: reset(setSearch),
    mode,
    setMode: reset(setMode),
    stage,
    setStage: reset(setStage),
    customer,
    setCustomer: reset(setCustomer),
    page,
    setPage,
    shown,
  };
}

export type ShipmentFilters = ReturnType<typeof useShipmentFilters>;
